import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { withNamespaces } from "react-i18next";

function ConfirmationAlert({
  showAdminModal,
  closeConfirmationAlert,
  confirm,
  confirmationText,
  headerText,
  message,
  closeLabel,
  confirmLabel,
  t,
}) {
  return (
    <Modal show={showAdminModal} onHide={closeConfirmationAlert}>
      <Modal.Header closeButton>
        <Modal.Title>{headerText}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          {message || (
            <>
              Are you sure you want to{" "}{confirmationText}
            </>
          )}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={closeConfirmationAlert}>
          {closeLabel || t("closeButton")}
        </Button>
        <Button variant="primary" onClick={confirm}>
          {confirmLabel || t("confirmButton")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default withNamespaces()(ConfirmationAlert);
